module.exports = __webpack_public_path__ + "static/img/YN_H5.fdd450e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/YN_H5.png
// module id = yotQ
// module chunks = 34